import React from "react";
import { logClientError } from "@/lib/errorLogger";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    try {
      logClientError({
        source: "ErrorBoundary",
        message: error?.message || String(error),
        severity: "critical",
        stack_trace: error?.stack || info?.componentStack || "",
        additional: { componentStack: info?.componentStack?.substring(0, 2000) },
      });
    } catch (_) {}
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: "32px", maxWidth: "600px", margin: "40px auto", fontFamily: "sans-serif" }}>
          <h2 style={{ color: "#dc2626" }}>Coś poszło nie tak</h2>
          <p>Błąd został zgłoszony do administratora. Spróbuj odświeżyć stronę.</p>
          <pre style={{ background: "#f3f4f6", padding: "12px", borderRadius: "6px", fontSize: "12px", overflow: "auto" }}>
            {this.state.error?.message || String(this.state.error)}
          </pre>
          <button
            onClick={() => window.location.reload()}
            style={{ marginTop: "16px", padding: "8px 16px", background: "#2563eb", color: "white", border: 0, borderRadius: "6px", cursor: "pointer" }}
          >
            Odśwież
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
